import {Button, message, Modal, Spin} from "antd";
import {DeleteOutlined, PaperClipOutlined} from "@ant-design/icons";
import {deleteCustomerAsset, getCustomerAssets} from "../../apiService/RESTApi";
import {copyToClipboard} from "../../utility/clipboard.js";
import {useActiveCompanyData} from "../../hooks/CompanyHooks";


import React, {useEffect, useRef, useState} from "react";
import UploadAsset from "./UploadAsset";

export default function CustomerAssetManagerModal({ open, onCancel }) {

    const [assets, setAssets] = useState([]);
    const sortOrder = useRef("asc");
    const [uploadAsset, setUploadAsset] = useState(false);
    const [loading, setIsLoading] = useState(false);

    const activeCompanyData = useActiveCompanyData();

    useEffect(() => {
        if (open) {
            setIsLoading(true)
            loadAssets().then((assets) => {
                if (assets !== null) {
                    setAssets(assets);
                }
                setIsLoading(false)
            });
        }
        //eslint-disable-next-line
    }, [open]);

    const loadAssets = async () => {

        if (!activeCompanyData && !activeCompanyData?.uuid) {
            console.error("No active company data found");
            return [];
        }

        const data = await getCustomerAssets(activeCompanyData?.uuid);
        if (data.response.data !== null) {
            return data.response.data[0];
        }
    };

    const handleDeleteLocal = (id) => {
        setAssets((prev) => prev.filter((a) => a.customerAssetId !== id));
    };

    const handleSort = () => {
        const sorted = [...assets].sort((a, b) => a.name.localeCompare(b.name));
        const isAsc = sortOrder.current === "asc";
        setAssets(isAsc ? sorted : sorted.reverse());
        sortOrder.current = isAsc ? "desc" : "asc";
    };

    const handleUploadedAsset = (asset) => {
        setAssets((prev) => [...prev, asset]);
    };

    const handleDelete = async (id) => {
        try {
            let success = await deleteCustomerAsset(id);
            if (success) {
                handleDeleteLocal(id)
                message.success("Asset deleted");
            } else {
                message.error("Delete failed");
            }
        } catch {
            message.error("Delete failed");
        }
    };

    function closeModal() {
        setUploadAsset(false);
    }

    return (
        <>
            <Modal
                open={open}
                onCancel={onCancel}
                cancelText="Done"
                onRequestClose={onCancel}
                contentLabel="Customer Assets"
                className="modal"
                overlayClassName="overlay"
                shouldCloseOnOverlayClick={false}
                closeIcon={true}
                okText="Upload"
                onOk={() => {
                    setUploadAsset(true);
                }}
            >
                <Spin spinning={loading} tip="Loading..." size="medium">
                    <div className="assets-header">
                        <h2>Assets</h2>
                        <Button className="sort-button" onClick={handleSort}>
                            Sort by Name ({sortOrder.current === "asc" ? "Asc" : "Desc"})
                        </Button>
                    </div>

                    <ul className="assets-list">
                        {assets.map((asset) => (
                            <li className="asset-item" key={asset.customerAssetId}>
                                <Button className="delete-button" type="text" icon={<DeleteOutlined/>}
                                        onClick={() => handleDelete(asset.customerAssetId)}
                                />

                                <img className="asset-image" src={asset.url} alt={asset.name}/>
                                <span className="asset-url"> {asset.name}</span>
                                <Button className="copy-button" type="text" icon={<PaperClipOutlined/>}
                                        onClick={() => copyToClipboard(asset.url)}
                                />
                            </li>
                        ))}
                    </ul>
                </Spin>
            </Modal>

            <UploadAsset
                customerUuid={activeCompanyData.uuid}
                open={uploadAsset}
                onCancel={closeModal}
                onUploaded={handleUploadedAsset}
            />
        </>
    );
}